import type {
  IAuthorizePaymentData,
  IAuthorizePaymentResponse,
} from '../index.h'

export const createPaymentAsync = (
  data: IAuthorizePaymentData
): Promise<IAuthorizePaymentResponse> => {
  return new Promise((resolve, reject) => {
    if (window) {
      if (!('Accept' in window)) {
        reject(new Error('Authorize API is not available'))
      }

      // @ts-ignore: TS2339 because window.Accept not in default window object this add Authorize API
      window.Accept.dispatchData(
        data,
        (response: IAuthorizePaymentResponse) => {
          if (response.messages.resultCode === 'Ok') {
            resolve(response)
          }
          reject(response)
        }
      )
    }
  })
}
